<template>
  <div>
    <!-- 头部部分 -->
    <div class="head">
      <!-- 展示的搜索条件 -->
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item  prop="userId" v-if="adminShow">
          <el-cascader
            placeholder="代理商"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item  prop="iccid">
          <el-input v-model="queryParams.iccid" placeholder="ICCID" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item  prop="status">
          <el-select v-model="queryParams.status" filterable placeholder="自动续费状态" @change="search" clearable>
            <el-option v-for="item in renewalStatusL" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-first-aid-kit" @click="packageRenewal">套餐续费</el-button>
          <el-button type="primary" icon="el-icon-open" @click="multipleSwitchOpen">自动续费开</el-button>
          <el-button type="primary" icon="el-icon-turn-off" @click="multipleSwitchUp">自动续费关</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 内容部分 -->
    <div class="table" style="margin-top: 20px">
      <el-table :data="tableData" border @selection-change="handleSelectionChange" :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="username" label="昵称" align="center" width="180px" v-if="adminShow"></el-table-column>
        <el-table-column prop="companyName" label="代理商" align="center"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
        <el-table-column prop="cardStatus" label="状态" align="center"></el-table-column>
        <el-table-column prop="status" label="自动续费开关" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#DCDFE6"
              active-value="1"
              inactive-value="0"
              @change="alonerenewChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="expireProductName" label="到期续费套餐" align="center"></el-table-column>
        <el-table-column prop="flowProductName" label="流量用完套餐" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { renewalIndex } from "@/api/api.js";//自动续费卡列表
import { agentTreeList } from "@/api/api.js"; //代理商
import { autoRenewalStatus } from "@/api/api.js";//用户单个开关自动续费
import { autoRenewalStatusBatch } from "@/api/api.js";//用户批量开关自动续费
export default {
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      packageList:[],
      agentTree:[],
      renewalStatusL:[
        {
          value: "0",
          label: "关闭"
        },
        {
          value: "1",
          label: "开启"
        },
      ],
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    inventoryStatusType(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.pagePackage,
        pageSize: this.pageSizePackage,
      };
      renewalIndex(params).then(res => {
        this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
            item.cardStatus = this.inventoryStatusType(item.cardStatus);
          })
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 单卡的续费开关
    alonerenewChange(val){
      let params = {
        id:val.id,
        status:""
      };
      params.status = val.status == "1" ? "1" : "0";
      autoRenewalStatus(params).then(res=>{
        if(res.data.code == 200){
          this.initData();
        }else{
          this.$message.error(res.data.message);
          this.initData();
        }
      })
    },
    // 跳转充值套餐页面
    packageRenewal(){
      this.$router.push("/users/renewal");
    },
    // 多选单选的值
    handleSelectionChange(val){
      let arrlist = [];
      val.map(item=>{
        arrlist.push(item.iccid);
      })
      this.packageList = arrlist;
    },
    // 多选自动续费开
    multipleSwitchOpen(){
      if(this.packageList == 0){
        return this.$message.error('请选择要续费的卡号');
      }else{
        let params = {
          iccids:this.packageList,
          status:1
        };
        autoRenewalStatusBatch(params).then(res=>{
          if(res.data.code == 200){
            this.initData();
            this.$notify({
              title: '成功',
              message: '批量开启自动续费成功',
              type: 'success'
            });
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    // 多选自动续费关
    multipleSwitchUp(){
      if(this.packageList == 0){
        return this.$message.error('请选择要续费的卡号');
      }else{
        let params = {
          iccids:this.packageList,
          status:0
        };
        autoRenewalStatusBatch(params).then(res=>{
          if(res.data.code == 200){
            this.initData();
            this.$notify({
              title: '成功',
              message: '批量关闭自动续费成功',
              type: 'success'
            });
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
  },
  created() {
    
  },
  mounted() {
    this.initData();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
  },
};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
.iclass-text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}
</style>


